module.exports = __webpack_public_path__ + "3547149d3259d52f320d4b15f9a43b98.png";